export const DATE_FORMAT = 'dd.MM.YYYY mm:HH';
export const DELIVERY_PROVIDER_ID = 'oJ5GNgMDGd9NDerfw';
